import { QrLookupPresentationType, type QrLookupResult } from './types'

export type QrLookupHeaderIcon = {
  iconVariant: 'error' | 'warning' | 'neutral' | 'info'
  iconClass: string
}

export function getQrLookupHeaderIcon(
  presentationType: QrLookupPresentationType
): QrLookupHeaderIcon {
  switch (presentationType) {
    case QrLookupPresentationType.Error:
      return { iconVariant: 'error', iconClass: 'isax-close-01' }
    case QrLookupPresentationType.Warning:
      return { iconVariant: 'warning', iconClass: 'isax-clock' }
    case QrLookupPresentationType.Success:
    default:
      return { iconVariant: 'info', iconClass: 'isax-eye' }
  }
}

export function isLookupBanner(result: QrLookupResult): boolean {
  return result.presentationType !== QrLookupPresentationType.Success
}

/** Renders API text with real line breaks (handles literal `\n` in payload). */
export function formatQrMultilineText(text: string | undefined | null): string {
  if (!text) return ''
  return text
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\r\n/g, '\n')
}

export function parsePresentationType(
  type: string | undefined
): QrLookupPresentationType {
  if (type === QrLookupPresentationType.Warning) {
    return QrLookupPresentationType.Warning
  }
  if (type === QrLookupPresentationType.Error) {
    return QrLookupPresentationType.Error
  }
  if (type === QrLookupPresentationType.Success) {
    return QrLookupPresentationType.Success
  }
  return QrLookupPresentationType.Error
}

/** @deprecated Used by QrScanRejectPanel if re-enabled */
export type QrRejectPresentation = {
  iconVariant: QrLookupHeaderIcon['iconVariant']
  iconClass: string
  title: string
  subtitle: string
  description: string
  descriptionHtml?: boolean
}
